module.exports = __webpack_public_path__ + "static/media/close.dcd60851.svg";